<div class="wl-history">
  <!-- Filtros + búsqueda -->
  <div class="wl-filters">
    <span class="wl-search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text" [(ngModel)]="search" (ngModelChange)="apply()" placeholder="Buscar por folio o título…" />
    </span>
    <p-dropdown [options]="typeOptions" [(ngModel)]="filterType" (onChange)="apply()" optionLabel="label"
      optionValue="value" placeholder="Tipo" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <p-dropdown [options]="areaOptions" [(ngModel)]="filterArea" (onChange)="apply()" optionLabel="label"
      optionValue="value" placeholder="Área" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <p-dropdown [options]="sprintOptions" [(ngModel)]="filterSprint" (onChange)="apply()" optionLabel="label"
      optionValue="value" placeholder="Sprint" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <p-dropdown [options]="outcomeOptions" [(ngModel)]="filterOutcome" (onChange)="apply()" optionLabel="label"
      optionValue="value" placeholder="Desenlace" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <button type="button" class="wl-clear" *ngIf="search || filterType || filterArea || filterSprint || filterOutcome" (click)="clear()">
      <i class="fa-solid fa-xmark"></i> Limpiar
    </button>
    <!-- Igual que en el backlog: mientras carga, el conteo no se afirma. -->
    <span class="wl-count" *ngIf="!loading">{{ items.length }} {{ filterOutcome === 'Cancelada' ? 'canceladas' : 'en el historial' }}</span>
  </div>

  <div class="sk-list" *ngIf="loading" aria-busy="true" aria-label="Cargando historial">
    <div class="sk-row" *ngFor="let i of [1,2,3,4,5,6,7]" [ngClass]="'sk-fade-' + (i > 4 ? 4 : i)">
      <p-skeleton shape="circle" size="1rem"></p-skeleton>
      <p-skeleton shape="circle" size="1rem"></p-skeleton>
      <div class="sk-main">
        <p-skeleton height="0.85rem" [width]="i % 3 === 0 ? '45%' : i % 2 === 0 ? '70%' : '58%'"></p-skeleton>
        <p-skeleton height="0.6rem" width="4.5rem" borderRadius="999px"></p-skeleton>
      </div>
      <div class="sk-right">
        <p-skeleton height="0.7rem" width="2rem" borderRadius="999px"></p-skeleton>
        <p-skeleton height="0.7rem" width="2.6rem"></p-skeleton>
        <p-skeleton shape="circle" size="1.4rem"></p-skeleton>
        <p-skeleton height="0.7rem" width="4.5rem"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="wl-state" *ngIf="!loading && !items.length">
    <i class="fa-solid fa-box-archive"></i>
    <p>No hay tareas en el historial con estos filtros.</p>
  </div>

  <div class="wl-list" *ngIf="!loading && items.length">
    <div class="wl-row" *ngFor="let it of items; trackBy: trackId" [class.is-cancelled]="it.status === 'Cancelada'"
      (click)="openItem.emit(it._id)">
      <span class="wl-check" *ngIf="it.status !== 'Cancelada'" title="Entregada"><i class="fa-solid fa-circle-check"></i></span>
      <span class="wl-check cancelled" *ngIf="it.status === 'Cancelada'" title="Cancelada"><i class="fa-solid fa-ban"></i></span>
      <span class="wl-row-type" [style.color]="TYPE_META[it.type].color" [title]="TYPE_META[it.type].label">
        <i [class]="TYPE_META[it.type].icon"></i>
      </span>
      <div class="wl-row-main">
        <span class="wl-row-title"><span class="wl-code" *ngIf="it.code">{{ it.code }}</span>{{ it.title }}</span>
        <div class="wl-row-tags">
          <span class="wl-area" *ngFor="let a of it.areas" [style.background]="areaMeta(a)?.color + '1a'"
            [style.color]="areaMeta(a)?.color">
            <i [class]="areaMeta(a)?.icon"></i> {{ areaMeta(a)?.short }}
          </span>
          <span class="wl-origin" *ngIf="it.origin === 'proposed'" [style.color]="ORIGIN_META.proposed.color"
            [title]="ORIGIN_META.proposed.label"><i [class]="ORIGIN_META.proposed.icon"></i></span>
        </div>
      </div>
      <span class="wl-sprint" *ngIf="sprintOf(it)">S{{ sprintOf(it) }}</span>
      <span class="wl-pts" *ngIf="it.points != null">{{ it.points }} pts</span>
      <span class="wl-req" [title]="'Solicitó: ' + userName(it.createdBy)"><span class="ava">{{ initials(it.createdBy) }}</span></span>
      <span class="wl-date">{{ completedAt(it) | date: 'dd MMM y' }}</span>
      <i class="fa-solid fa-chevron-right wl-chev"></i>
    </div>
  </div>
</div>
